import { render, staticRenderFns } from "./Breadcrumb.vue?vue&type=template&id=5d1cff66&scoped=true"
import script from "./Breadcrumb.vue?vue&type=script&setup=true&lang=js"
export * from "./Breadcrumb.vue?vue&type=script&setup=true&lang=js"
import style0 from "./Breadcrumb.vue?vue&type=style&index=0&id=5d1cff66&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d1cff66",
  null
  
)

export default component.exports